import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Press } from '@dorixona/ui'
import { formatMoney } from '@dorixona/utils'
import { Icon } from '../../ui/Icon'
import { Loading } from '../../ui/Load'
import { Photo } from '../../ui/Photo'
import { QtyStepper } from '../../ui/QtyStepper'
import { useSession } from '../../app/session'
import { useCart } from './CartProvider'
import { issueKey } from './model'
import { usePoints } from '../../ui/points'

export function CartScreen() {
  const navigate = useNavigate()
  const cart = useCart()
  const { isAuthenticated } = useSession()
  const { t } = useTranslation(['cart', 'catalog', 'common'])
  const { formatPoints } = usePoints()

  if (cart.loading) {
    return (
      <section className="screen cart-wrap">
        <div className="mhead">
          <h1>{t('cart:title')}</h1>
        </div>
        <Loading what={t('common:state.loading')} count={2} />
      </section>
    )
  }

  return (
    <section className="screen cart-wrap">
      <div className="mhead">
        <h1>{t('cart:title')}</h1>
      </div>

      {cart.lines.length === 0 ? (
        <div className="card empty">
          <Icon name="i-cart" size={54} />
          <div className="t">{t('cart:empty')}</div>
          {t('cart:emptyHint')}
          <div style={{ marginTop: 18 }}>
            <Button
              onPress={() => {
                void navigate('/catalog')
              }}
            >
              {t('common:actions.toCatalog')}
            </Button>
          </div>
        </div>
      ) : (
        <div className="cart-grid">
          <div className="card cg-items" style={{ marginBottom: 16 }}>
            {cart.lines.map((line) => (
              <div key={line.productId} className="crow">
                {/* Фото и название ведут на товар; снятый с витрины открыть нельзя. */}
                <Press
                  squish="row"
                  className="crow__link"
                  disabled={!line.active}
                  onPress={() => {
                    void navigate(`/catalog/${line.productId}`)
                  }}
                >
                  <div className="cimg">
                    <Photo src={line.photo} alt="" iconSize={30} />
                  </div>
                  <div className="cinfo">
                    <div className="n">{line.name}</div>
                    {/* Остаток упал ниже лежащего в корзине: сервер тогда шлёт
                        `in_stock: false`, но товар не кончился — говорим, сколько есть. */}
                    {line.active && line.maxQty > 0 && line.qty > line.maxQty ? (
                      <div className="v" style={{ color: 'var(--rx)' }}>
                        {t('cart:available', { count: line.maxQty })}
                      </div>
                    ) : line.active && line.inStock ? null : (
                      <div className="v" style={{ color: 'var(--rx)' }}>
                        {t(line.active ? 'cart:gone' : 'cart:removed')}
                      </div>
                    )}
                    <div className="p num">
                      {formatMoney(line.total)}
                      {line.qty > 1 ? (
                        <span
                          style={{ fontWeight: 500, color: 'var(--text2)', fontSize: '12.5px' }}
                        >
                          {' '}
                          {line.qty} × {formatMoney(line.price)}
                        </span>
                      ) : null}
                    </div>
                  </div>
                </Press>
                <QtyStepper
                  productId={line.productId}
                  quantity={line.qty}
                  max={line.maxQty}
                  onChange={(delta) => {
                    cart.changeQuantity(line.productId, delta, line.maxQty)
                  }}
                />
              </div>
            ))}
          </div>

          <div className="cg-side">
            <div className="card totals" style={{ marginBottom: 16 }}>
              <div className="tr">
                <span>{t('cart:goods')}</span>
                <b className="num">{formatMoney(cart.goods)}</b>
              </div>
              <div className="tr">
                <span>{t('cart:cashback')}</span>
                <b className="num" style={{ color: 'var(--gold)' }}>
                  +{formatPoints(cart.cashback)}
                </b>
              </div>
              {cart.hasRx ? (
                <div className="rx-note" style={{ marginTop: 12 }}>
                  <Icon name="i-info" size={18} />
                  {t('cart:rxNote')}
                </div>
              ) : null}
              {cart.issues.map((issue) => (
                <div key={issue} className="rx-note" style={{ marginTop: 12 }}>
                  <Icon name="i-info" size={18} />
                  {t(issueKey(issue))}
                </div>
              ))}
            </div>
            <Button
              onPress={() => {
                void navigate(isAuthenticated ? '/checkout' : '/login')
              }}
            >
              {t('cart:checkout')}
            </Button>
          </div>
        </div>
      )}
    </section>
  )
}
